import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { uploadProjectImage } from "../../redux/slices/projectEditSlice"; // Thunk'ı import et

const ImageUpload = ({ initialImage, relatedId }) => {
  const dispatch = useDispatch(); // useDispatch'i burada tanımla
  const [image, setImage] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  // initialImage props'u değiştiğinde state'i güncelle
  useEffect(() => {
    if (initialImage) {
      setImage(`data:image/jpeg;base64,${initialImage}`); // Base64 string'i uygun formata çevir
    } else {
      setImage(null);
    }
  }, [initialImage]);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setImage(URL.createObjectURL(file)); //dosya önizleme oluştur, state kaydet
      // Görseli backend'e yükle
      dispatch(uploadProjectImage({ relatedId, file }));
    }
  };
  const removeImage = () => {
    setImage(null);
    setSelectedFile(null);
  };

  return (
    <div className="detay-container w-[232px] min-h-[248px] p-4 items-center">
      <div className=" w-[200px] h-[112px] border-[1px] flex items-center justify-center rounded-xl overflow-hidden ">
        <img
          src={image || "/projeimg.svg"}
          alt="Proje Image"
          className="w-full h-full object-cover"
        />
      </div>
      <label
        className="btn-green w-[200px] h-[36px] flex items-center justify-center 
        cursor-pointer mx-auto sm:mx-0 border-none text-xs leading-[16px]"
      >
        Proje Görseli Seç
        <input
          type="file"
          accept="image/*"
          className="hidden "
          onChange={handleImageChange}
        />
      </label>
      <button
        className="btn-second w-[200px] h-[36px] text-gray-400 text-xs font-medium leading-[16px]"
        onClick={removeImage}
        disabled={!image}
      >
        Görseli Kaldır
      </button>
    </div>
  );
};
export default ImageUpload;
